var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }
            if (t && _.label < t[2]) {
              _.label = t[2];
              _.ops.push(op);
              break;
            }
            if (t[2]) _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
import { isBlank, isFunction } from '@autobest-ui/utils';
import InterceptorManager from './interceptorManager';
import combineParamsToUrl from './combineParamsToUrl';
import merge from './merge';
import { defaultConfig } from './defaultConfig';
import { defaultTransformRequest, defaultTransformResponse, defaultTransformResponseError } from './transforms';
import disassembleRequestArgs from './disassembleRequestArgs';
import xhrAdapter from './xhrAdapter';
var CreateAjax = /** @class */function () {
  function CreateAjax(config) {
    var _this = this;
    this.interceptor = {
      request: new InterceptorManager(),
      response: new InterceptorManager()
    };
    this.setGlobalConfig = function (config) {
      _this._config = config;
    };
    this.setGlobalConfig(config);
  }
  CreateAjax.getInstance = function () {
    // 单例模式
    return CreateAjax._instance || (CreateAjax._instance = new CreateAjax());
  };
  CreateAjax.prototype.request = function (requestArgs) {
    return __awaiter(this, void 0, void 0, function () {
      var mergeRequestArgs, newRequestArgs, combineParamsInfo, beforeRequest, requestInterceptor, _a, resolveHandle, rejectHandle, xhrResponse, afterRequest, responseInterceptor, _loop_1;
      return __generator(this, function (_b) {
        if (isBlank(requestArgs.url) && isBlank(requestArgs.href)) {
          throw new Error('Provided url is not valid');
        }
        mergeRequestArgs = merge(defaultConfig, this._config, requestArgs);
        newRequestArgs = defaultTransformRequest(mergeRequestArgs);
        combineParamsInfo = combineParamsToUrl(newRequestArgs.url, newRequestArgs.params);
        // 主要用于中间件对剩余参数的处理
        newRequestArgs.surplusParams = combineParamsInfo.surplusParams;
        beforeRequest = newRequestArgs.beforeRequest;
        if (isFunction(beforeRequest)) {
          newRequestArgs = beforeRequest(newRequestArgs);
        }
        requestInterceptor = this.interceptor.request.get();
        while (requestInterceptor.length) {
          _a = requestInterceptor.shift(), resolveHandle = _a.resolveHandle, rejectHandle = _a.rejectHandle;
          try {
            newRequestArgs = resolveHandle(newRequestArgs);
          } catch (error) {
            if (rejectHandle) {
              rejectHandle(error);
            }
            break;
          }
        }
        newRequestArgs.href = "".concat(newRequestArgs.baseUrl || '').concat(combineParamsInfo.url);
        newRequestArgs.requestConfig.method = newRequestArgs.requestConfig.method || 'get';
        try {
          xhrResponse = xhrAdapter(newRequestArgs);
        } catch (error) {
          return [2 /*return*/, Promise.reject(error)];
        }
        xhrResponse = xhrResponse.then(function (currentXhrResponse) {
          return defaultTransformResponse(currentXhrResponse, newRequestArgs);
        }, function (reason) {
          return defaultTransformResponseError(reason);
        });
        afterRequest = newRequestArgs.afterResponse;
        if (isFunction(afterRequest)) {
          xhrResponse = xhrResponse.then(function (nextResponse) {
            return afterRequest(nextResponse, newRequestArgs);
          }, function (reason) {
            return Promise.reject(reason);
          });
        }
        responseInterceptor = this.interceptor.response.get();
        _loop_1 = function _loop_1() {
          var _c = responseInterceptor.shift(),
            resolveHandle = _c.resolveHandle,
            rejectHandle = _c.rejectHandle;
          xhrResponse = xhrResponse.then(function (resolveInfo) {
            return isFunction(resolveHandle) ? resolveHandle(resolveInfo, newRequestArgs) : Promise.resolve(resolveInfo);
          }, function (rejectInfo) {
            return isFunction(rejectHandle) ? rejectHandle(rejectInfo, newRequestArgs) : Promise.reject(rejectInfo);
          });
        };
        while (responseInterceptor.length) {
          _loop_1();
        }
        return [2 /*return*/, xhrResponse];
      });
    });
  };
  /**
   * GET
   * @param url
   * @param params
   * @param options
   */
  CreateAjax.prototype.get = function (url, params, options) {
    var requestArgs = disassembleRequestArgs(url, 'get', params, null, options);
    return this.request(requestArgs);
  };
  /**
   * POST
   * @param url
   * @param body 请求体
   * @param params
   * @param options
   * @returns {*}
   */
  CreateAjax.prototype.post = function (url, body, params, options) {
    var requestArgs = disassembleRequestArgs(url, 'post', params, body, options);
    return this.request(requestArgs);
  };
  /**
   * DELETE
   * @param url
   * @param params
   * @param options
   * @returns {*}
   */
  CreateAjax.prototype["delete"] = function (url, params, options) {
    var requestArgs = disassembleRequestArgs(url, 'delete', params, null, options);
    return this.request(requestArgs);
  };
  /**
   * PUT
   * @param url
   * @param body
   * @param params
   * @param options
   * @returns {*}
   */
  CreateAjax.prototype.put = function (url, body, params, options) {
    var requestArgs = disassembleRequestArgs(url, 'put', params, body, options);
    return this.request(requestArgs);
  };
  return CreateAjax;
}();
export { CreateAjax };
// 推荐使用单例模式
var Ajax = CreateAjax.getInstance();
export default Ajax;